import { isEmpty } from "lodash-es";
import { Button, DeleteIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import { Key } from "antd/lib/table/interface";
import { useDeleteForwards } from "../../hooks/urlforward/useDeleteForwards";
import { useConfirm } from "melco-shared-logic";

type BulkActionDeleteForwardsProps = {
    selectedRowKeys: Key[];
    setSelectedRowKeys: (keys: Key[]) => void;
    refetch?: () => Promise<any>;
};

export const BulkActionDeleteForwardsProps: React.FC<
    BulkActionDeleteForwardsProps
> = ({ selectedRowKeys, setSelectedRowKeys, refetch }) => {
    const { t } = useTranslation();

    const deleteForwards = useDeleteForwards();

    const confirmDelete = useConfirm(
        async () => {
            const successfullyDeletedIds = await deleteForwards(
                selectedRowKeys.map((key) => key.toString())
            );

            if (refetch) {
                refetch();
            }

            // keep items that were not deleted selected
            setSelectedRowKeys(
                selectedRowKeys.filter(
                    (id) => !successfullyDeletedIds.includes(id.toString())
                )
            );
        },
        {
            translationPrefix: selectedRowKeys.length > 1 ? "url_forward.actions.delete_multiple" : "url_forward.actions.delete",
            translationOptions: {
                count: selectedRowKeys.length,
            },

        }
    );

    if (isEmpty(selectedRowKeys)) {
        return null;
    }

    return (
        <Button
            key="bulk-download"
            icon={<DeleteIcon />}
            onClick={async () => {
                await confirmDelete();
            }}
        >
            {t("url_forward.actions.delete.title")}
        </Button>
    );
};
